import { creatorsReportEndpointIds } from 'root/src/shared/creatorsReport/creatorsReport.constants';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
export const initRefreshCreatorsReportEndpoint = {
    [creatorsReportEndpointIds.INIT_REFRESH_CREATORS_REPORT]: {
        endpointType: otherEndpointType,
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
    },
};
